const set = (property) => (store, payload) => (store[property] = payload)

const setIsReady = set('isReady')
const setIsLoading = set('isLoading')
const setUser = (state, user) => {
  state.user = { ...user }
  state.session = state.user.signInUserSession
}

export { setIsReady, setIsLoading, setUser }
